export const InvoiceNotesValidation = (formData) => {
    const errors = {};
   
    if (!formData.vc_Description || formData.vc_Description==="") {
        errors.vc_Description = 'This field is required';
    }
    if (!formData.dt_Created || formData.dt_Created==="") {
        errors.dt_Created = 'This field is required';
    }
    
    return errors;
};
